import { noop } from 'lodash-es'

import { LayerToggle } from './LayerToggle'
import { useMapMode } from './useMapMode'

export type MapModeLayerToggleProps = {
  value?: boolean
  onValueChange?: (value: boolean) => void
}

export const MapModeLayerToggle = ({
  value = false,
  onValueChange = noop,
}: MapModeLayerToggleProps) => {
  const { useSatellite, toggleMapMode } = useMapMode(value, onValueChange)

  return (
    <LayerToggle
      name="Standard / Satellite"
      value={useSatellite}
      setValue={toggleMapMode}
      testId="layer-manager-satellite-toggle"
    />
  )
}
